// Angular
import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
// RxJS
import { finalize, takeUntil, tap } from 'rxjs/operators';
import { Observable, Subject } from 'rxjs';
// Translate
import { TranslateService } from '@ngx-translate/core';
// Auth
import { AuthNoticeService, AuthService, Login } from '../../../../core/auth';
import { ConfirmPasswordValidator } from './confirm-password.validator';
import Swal from 'sweetalert2'
import { Store } from '@ngrx/store';
import { AppState } from '../../../../core/reducers';
import { VacanciesService } from '../../../../core/vacancy/vacancies.service';
import { CenterService } from '../../../../core/center/center.service';
@Component({
	selector: 'kt-otp',
	templateUrl: './otp.component.html',
	styleUrls: ['./otp.component.scss']
})
export class OTPComponent implements OnInit, OnDestroy {
	// Public params
	forgotPasswordForm: FormGroup;
	loading = false;
	isLoggedIn$: Observable<boolean>;
	errors: any = [];
	public requestNumber: any;

	private unsubscribe: Subject<any>; // Read more: => https://brianflove.com/2016/12/11/anguar-2-unsubscribe-observables/

	/**
	 * Component constructor
	 *
	 * @param authService
	 * @param authNoticeService
	 * @param translate
	 * @param router
	 * @param fb
	 * @param cdr
	 */
	constructor(
		private authService: AuthService,
		public authNoticeService: AuthNoticeService,
		private translate: TranslateService,
		private router: Router,
		private fb: FormBuilder,
		private store: Store<AppState>,
		private cdr: ChangeDetectorRef,
		private route: ActivatedRoute,
		private vacanCyService: VacanciesService,
		private centerService: CenterService
	) {
		this.unsubscribe = new Subject();
	}

	/**
	 * @ Lifecycle sequences => https://angular.io/guide/lifecycle-hooks
	 */

	/**
	 * On init
	 */
	ngOnInit() {
		this.initRegistrationForm();
		this.requestNumber = this.route.snapshot.queryParamMap.get('email')
		// alert(this.requestNumber)
	}

	/**
	 * On destroy
	 */
	ngOnDestroy(): void {
		this.unsubscribe.next();
		this.unsubscribe.complete();
		this.loading = false;
	}

	/**
	 * Form initalization
	 * Default params, validators
	 */
	initRegistrationForm() {
		this.forgotPasswordForm = this.fb.group({

			otp: ['', Validators.compose([
				Validators.required

			])
			],

		},
		);

	}

	/**
	 * Form Submit
	 */
	submit() {
		const controls = this.forgotPasswordForm.controls;
		/** check form */
		if (this.forgotPasswordForm.invalid) {
			Object.keys(controls).forEach(controlName =>
				controls[controlName].markAsTouched()
			);
			return;
		}

		this.loading = true;

		const password = controls.otp.value;
		this.authService.verifyOTP(password, this.requestNumber).pipe(
			tap(response => {
				if (response) {
					this.authNoticeService.setNotice('OTP verification successful', 'success');
					this.isLoggedIn$
					this.store.dispatch(new Login({ authToken: response.jwt }));
					localStorage.setItem('token', response.jwt);
					this.checOutsidekposting();

					this.checkposting()

				} else {

					this.authNoticeService.setNotice('OTP verification failed', 'danger');
				}
			}),
			takeUntil(this.unsubscribe),
			finalize(() => {
				this.loading = false;
				this.cdr.markForCheck();
			})
		).subscribe(data => {
			Swal.fire(
				'OTP verification Successful',
				`You have been logged in successfully`,
				'success'
			)
			this.isLoggedIn$
					this.store.dispatch(new Login({ authToken: data.jwt }));
					localStorage.setItem('token', data.jwt);
					this.checOutsidekposting();

					this.checkposting()
			
		}, error => {
			Swal.fire(
				error.error.message,
				`OTP verification failed  `,
				'error'
			)
		});
	}

	/**
	 * Checking control validation
	 *
	 * @param controlName: string => Equals to formControlName
	 * @param validationType: string => Equals to valitors name
	 */
	isControlHasError(controlName: string, validationType: string): boolean {
		const control = this.forgotPasswordForm.controls[controlName];
		if (!control) {
			return false;
		}

		const result =
			control.hasError(validationType) &&
			(control.dirty || control.touched);
		return result;
	}

	checkposting() {
		this.vacanCyService.checkposting().subscribe((data) => {
			//alert("Cheked fine")
			localStorage.setItem('PostDetails', JSON.stringify(data[0]))

			this.router.navigateByUrl('main/dashboard'); // Main page

			//this.posted = true;
		}, error => {
			console.log('checked error')
			//localStorage.removeItem('PostDetails')
			this.router.navigateByUrl('main/dashboard'); // Main page
		})
	}

	checOutsidekposting() {

		this.centerService.checkOusitePosting().subscribe((data) => {

			localStorage.setItem('OutsidePostDetails', JSON.stringify(data))

		}, error => {

		})
	}
}
